import React from 'react'
import clsx from 'clsx'
import RSelect from 'react-select'
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import styles from './Select.module.scss';

export type OptionType = {
  value: 'newest' | 'oldest'
  label: string,
  icon?: string,
}

export type SelectProps = {
  value?: OptionType,
  onChange?: (v: any) => void,
  className?: string,
  options: OptionType[] | any,
  Menu?: (props: any) => JSX.Element,
  optionClassName?: string,
  secondary?: boolean,
}

function DropdownIndicator(props: any) {
  return (<IconArrow {...props} className={styles.dropdownIndicator} />)
}

export function Select({
  value = undefined,
  onChange = () => { },
  options = [],
  className = '',
  optionClassName = '',
  Menu,
  secondary = false,
}: SelectProps) {
  const components: any = {}
  if (DropdownIndicator) components.DropdownIndicator = DropdownIndicator
  if (Menu) components.Menu = Menu
  const style = {
    menuList: (base) => ({
      ...base,

      '::-webkit-scrollbar': {
        width: '4px',
        height: '0px',
      },
      '::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '::-webkit-scrollbar-thumb': {
        background: '#888',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  }
  return (
    <RSelect
      classNames={{
        container: () => clsx(className, styles.select, secondary && styles.select_secondary),
        indicatorSeparator: () => styles.indicatorSeparator,
        control: () => styles.control,
        valueContainer: () => styles.valueContainer,
        singleValue: () => styles.singleValue,
        menu: () => clsx(optionClassName, styles.menu),
        menuList: () => styles.menuList,
        option: (props: any) => clsx(styles.option, props.isSelected && styles.optionSelected),
      }}
      styles={style}
      components={components}
      value={value}
      onChange={onChange}
      options={options}
      isSearchable={false}
    // defaultMenuIsOpen
    />
  )
}
